import { useState, useEffect } from 'react';

const WebinarPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show popup immediately on component mount
    setIsVisible(true);
  }, []);

  const handlePopupClick = () => {
    // Redirect to US Tax Webinar page
    window.open('https://www.bookscomply.com/us-tax-return-webinar', '_blank', 'noopener,noreferrer');
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handlePopupClick}
    >
      <div 
        className="relative bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl transform transition-all"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold leading-none"
          aria-label="Close popup"
        >
          ×
        </button>

        {/* Popup content */}
        <div className="text-center">
          <div className="mb-6">
            <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              US Tax Return 2025 Webinar
            </h2>
            <p className="text-gray-600 mb-4">
              Key Changes & Complex Issues
            </p>
            <div className="space-y-2 text-sm text-gray-500">
              <p>📅 Saturday, 14th March 2026</p>
              <p>🕘 IST: 9:00 PM | EST: 10:30 AM</p>
              <p>💻 Online Webinar</p>
            </div>
          </div>

          <button
            onClick={handlePopupClick}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Register Now - Free!
          </button>

          <p className="text-sm text-gray-500 mt-4">
            Expert-led session • Live Q&A • Limited seats
          </p>
        </div>
      </div>
    </div>
  );
};

export default WebinarPopup;
